import { translateTo } from '@/utils/locale';
import { merge, cloneDeep } from 'lodash';

const gauge = {
  series: [
    {
      name: '风向',
      type: 'gauge',
      detail: {
        formatter: '{value}°'
      },
      axisLine: {
        length: 20,
        lineStyle: {
          color: [[1, '#00e1f3']]
        }
      },
      axisTick: {
        distance: -8,
        length: 5,
        lineStyle: {
          color: '#fff',
          width: 2
        }
      },
      startAngle: 90,
      splitNumber: 8,
      endAngle: 449,
      min: 0,
      max: 360,
      title: {
        color: '#fff',
        fontSize: 14,
        fontWeight: 800,
        fontFamily: 'Arial',
        offsetCenter: [0, 0]
      },
      axisLabel: {
        fontSize: 15,
        distance: -60,
        rotate: 'tangential',
        formatter: function (value) {
          let str;
          if (value === 0) {
            str = '北';
          } else if (value === 45) {
            str = '东北';
          } else if (value === 90) {
            str = '东';
          } else if (value === 135) {
            str = '东南';
          } else if (value === 180) {
            str = '南';
          } else if (value === 225) {
            str = '西南';
          } else if (value === 270) {
            str = '西';
          } else if (value === 315) {
            str = '西北';
          }

          return translateTo(str);
        }
      },
      data: [
        {
          value: 0,
          name: translateTo('北')
        }
      ]
    }
  ]
};

const line = {
  tooltip: { trigger: 'axis' },
  backgroundColor: '#112132',
  textStyle: { color: '#00eeff' },
  grid: { left: '5%', top: '16%', bottom: '8%', right: '8%', containLabel: true },
  xAxis: {
    type: 'time',
    axisLine: { lineStyle: { color: '#d8dde6' } },
    splitLine: { lineStyle: { color: '#727a83' } }
  },
  yAxis: {
    type: 'value',
    nameTextStyle: {
      align: 'center',
      padding: [0, 0, 0, 20]
    },
    axisLine: { lineStyle: { color: '#d8dde6' } },
    splitLine: { lineStyle: { color: '#727a83' } },
    max(v) {
      if (v.max < 0) {
        return v.max / 2;
      }
      if (v.max == 0) {
        return v.max + 0.0001;
      }
      return v.max < 100 ? 2 * v.max : v.max + 100;
    }
  },
  series: [
    {
      type: 'line',
      symbol: 'roundRect',
      symbolSize: 6,
      smooth: true,
      markPoint: {
        label: { color: '#fff' },
        data: [
          { type: 'max', name: '最大值' },
          { type: 'min', name: '最小值' }
        ]
      },
      data: []
    }
  ]
};

const optional = {
  line,
  gauge
};

function mixinOption(color, op, type) {
  return merge(cloneDeep(optional[type]), { color, ...op });
}

const config = {
  bio: ['#6A8CAF', '个/秒', {}],
  smoke: ['#3FC5F0', '', {}],
  tvoc: ['#6DECB9', 'PPM', {}],
  cwa: ['#42DEE1', 'V', {}],
  nuclear: ['#728ee8', 'γ', {}],
  gcamera: ['#296eb3', 'uSv/h', {}],
  weather: ['#00e1f3', '', {}],
  sys: ['#6a77af', '', {}]
};

export function genYAxisNameOp(name) {
  return { yAxis: { name } };
}

function yAxisHandler(op, name) {
  return merge(genYAxisNameOp(name), op);
}

export function getOpt(args) {
  let { type, op, chartType } = { chartType: 'line', ...args };
  const [color, unit, opt] = cloneDeep(config[type]);
  if (unit) op = yAxisHandler(op, unit);
  return mixinOption(color, merge(opt, op), chartType);
}
